import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';


const ResourceRequest = () =>{
  
  return (
    <div className="ResourceRequest">
    
    <section className="inner-banner banner-align">
      <img className="img-fluid" src="./assets/img/innerbanner/resource-request.jpg" alt=""/>
    </section>
    <section  className="research-box-area">
         <Container>
       
            <div className='information-content'>
              <h2>Resource Request</h2>
              {/* <p>Your University ID card is also your library card. You can borrow the library materials by presenting your card. our University ID card is also your library card. You can borrow the library materials by presenting your card.</p> */}
              <p>This is for the use of HU learning community only and requires a valid HU email ID. Before placing your suggestion, please check in the HU Library Catalog to see if the book is already in the library collection or on order.</p>
              <p>Please supply complete and correct information. The more complete the form is, the faster the request will be processed (including ISBN).</p>
              <p>Average delivery time from vendors varies from four weeks to two months.</p>
              <a href="https://habibuniversity.sharepoint.com/sites/Faculty/Pages/library-resource-request.aspx" className="btn-dfault" target="_blank">Resource Request</a>
              
            </div>
            
         </Container>
    </section>
   
  </div>
  );
}
export default ResourceRequest;